import { Box, Tab, Tabs } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const tabs = [
  { path: 'campaign-performance', label: 'Campaign Performance' },
  { path: 'contribution', label: 'Contribution' },
  { path: 'dynamics', label: 'Dynamics' },
  { path: 'multi-deep-dive', label: 'Multi Deep Dive' },
]

export function ReviewPerformanceIndex() {
  const location = useLocation()
  const navigate = useNavigate()
  const current = tabs.findIndex((t) => location.pathname.endsWith(t.path))
  return (
    <Box>
      <Tabs
        value={current >= 0 ? current : 0}
        onChange={(_, i: number) => navigate({ pathname: tabs[i]!.path, search: location.search })}
      >
        {tabs.map((t) => (
          <Tab key={t.path} label={t.label} />
        ))}
      </Tabs>
      <Outlet />
    </Box>
  )
}
